import React from "react";
import moment from "moment";
import { Dropdown, Tooltip } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import {removeDuplicates} from "@components/help";
import {TwoDecimalFormat} from "@components/Format";

export const FacilityBenchmarkProps = {
    title: 'FacilityBenchmark',
    description: '',
    name: 'FacilityBenchmark'
}

export const FacilityBenchmarkColumns = (data, roleKey, handleDeleteBenchmark, facilityCategoryOptions = []) => {

    // 根据 facility_category ID 获取对应的名称
    const getFacilityCategoryName = (categoryId) => {
        if (!categoryId) return '-';
        const category = facilityCategoryOptions.find(item => item.id === categoryId);
        return category?.name || categoryId;
    };

    let yearOptions = data.map((e) => ({'label': e.year, 'value': e.year}))
    yearOptions = removeDuplicates(yearOptions)
    yearOptions.sort((a, b) => a.value - b.value)

    let categoryOptions = data.map((e) => ({'label': e.category, 'value': e.category}))
    categoryOptions = removeDuplicates(categoryOptions)
    categoryOptions.sort((a, b) => a.value - b.value)

    let regionOptions = data.map((e) => ({'label': e.region, 'value': e.region}))
    regionOptions = removeDuplicates(regionOptions)
    regionOptions.sort((a, b) => a.value - b.value)

    let cityOptions = data.map((e) => ({'label': e.city, 'value': e.city}))
    cityOptions = removeDuplicates(cityOptions)
    cityOptions.sort((a, b) => a.value - b.value)

    let stateOptions = data.map((e) => ({'label': e.state, 'value': e.state}))
    stateOptions = removeDuplicates(stateOptions)
    stateOptions.sort((a, b) => a.value - b.value)

    let countryOptions = data.map((e) => ({'label': e.country, 'value': e.country}))
    countryOptions = removeDuplicates(countryOptions)
    countryOptions.sort((a, b) => a.value - b.value)

    let climatezonOptions = data.map((e) => ({'label': e.climate_zone, 'value': e.climate_zone}))
    climatezonOptions = removeDuplicates(climatezonOptions)
    climatezonOptions.sort((a, b) => a.value - b.value)

    // Check if user has permission to delete (SuperUser or Account Manager)
    const canDelete = roleKey === 1 || roleKey === 2.1;

    const columns = [
        // {
        //     title: 'Company',
        //     dataIndex: 'company',
        //     key: 'company',
        //     edit: true,
        //     width: 150,
        //     fixed: 'left',
        //     ellipsis: {
        //         showTitle: false,
        //     },
        //     render: (text) => (
        //         <Tooltip placement="topLeft" title={text}>
        //             {text}
        //         </Tooltip>
        //     ),
        //     // sorter: (a, b) => a.Company.localeCompare(b.Company),
        // },
        {
            title: 'Facility',
            dataIndex: 'facility',
            key: 'facility',
            width: 200,
            fixed: 'left',
            ellipsis: {
                showTitle: false,
            },
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>
                    {text}
                </Tooltip>
            ),
        },
        {
            title: 'Year',
            dataIndex: 'year',
            key: 'year',
            width: 80,
            hideInTable: window.innerWidth < 760,
            render: (text, record) => (
                moment(record.year).format('YYYY')
            ),
            valueType: 'text',
        }, {
            title: 'Size (sqft)',
            dataIndex: 'size',
            key: 'size',
            width: 120,
        }, {
            title: 'Category',
            dataIndex: 'facility_category',
            key: 'facility_category',
            width: 180,
            render: (categoryId) => getFacilityCategoryName(categoryId),
        }, {
            title: 'EUI (kBtu/q-yr)',
            dataIndex: 'eui',
            key: 'eui',
            width: 140,
        }, {
            title: 'EUI - Elec(kBtu/sq-yr)',
            dataIndex: 'eui_elec',
            key: 'eui_elec',
            width: 180,
        }, {
            title: 'EUI - NG (kBtu/sq-yr)',
            dataIndex: 'eui_ng',
            key: 'eui_ng',
            width: 180,
        }, {
            title: 'Energy Costs ($)',
            dataIndex: 'energy_costs',
            key: 'energy_costs',
            width: 150,
        }, {
            title: 'Energy Costs ($/sqft)',
            dataIndex: 'energy_costs_sqft',
            key: 'energy_costs_sqft',
            width: 180,
            render: (text) => (
                TwoDecimalFormat(text)
            ),
        }, {
            title: 'Region',
            dataIndex: 'region',
            key: 'region',
            width: 120,
        }, {
            title: 'City',
            dataIndex: 'city',
            key: 'city',
            width: 120,
        }, {
            title: 'State',
            dataIndex: 'state',
            key: 'state',
            width: 100,
        }, {
            title: 'Country',
            dataIndex: 'country',
            key: 'country',
            width: 120,
        }, {
            title: 'Climate Zone',
            dataIndex: 'climate_zone',
            key: 'climate_zone',
            width: 120,
        },
    ];

    // Add action column if user has permission
    if (canDelete) {
        columns.push({
            title: '',
            key: 'action',
            width: 60,
            fixed: 'right',
            align: 'center',
            render: (text, record) => {
                const menuItems = [
                    {
                        key: 'delete',
                        icon: <DeleteOutlined />,
                        label: 'Delete',
                        onClick: () => handleDeleteBenchmark(record.id),
                    }
                ];

                return (
                    <Dropdown menu={{ items: menuItems }} trigger={['click']}>
                        <i className="fas fa-ellipsis-h text-lg" style={{ cursor: 'pointer', color: '#1890ff' }}></i>
                    </Dropdown>
                );
            },
        });
    }

    return columns;
};
